import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker/DayPicker';
import { removeTime } from "../../../../helpers/dateTime";
import './date_picker.scss';

export const DatePicker = ({
    disabled,
    enabledDays,
    initialDate,
    locale,
    maxDate,
    minDate,
    months,
    onDayClick,
    onMonthChange,
    selectedDays,
    weekdaysLong,
    weekdaysShort,
    variant = 'inline',
    yearsBackward,
    yearsForward
}) => {
    const currentYear = new Date().getFullYear();
    const monthsLabel = months ? months : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const weekdaysShortLabel = weekdaysShort ? weekdaysShort : ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"]

    if (disabled) {
        minDate = new Date();
        maxDate = new Date();
    } else {
        if (!minDate && yearsBackward) {
            minDate = new Date(currentYear - yearsBackward, 0);
        }

        if (!maxDate && yearsForward) {
            maxDate = new Date(currentYear + yearsForward, 11);
        }
    }

    minDate = removeTime(minDate);
    maxDate = removeTime(maxDate);

    const handleDayClick = (day, { selected, disabled }) => {
        if (onDayClick) {
            onDayClick(day, selected, disabled);
        }
    }

    const handleYearMonthChange = (month) => {
        if (onMonthChange) {
            onMonthChange(month);
        }
    }

    const isDayDisabled = (day, enabledDays, disabled) => {
        if (disabled === true) {
            return true;
        }
        else {
            if (enabledDays && enabledDays.length > 0) {
                var disableDay = enabledDays.some(disabledDay =>
                    DateUtils.isSameDay(day, disabledDay)
                );
                return (!disableDay);
            }
        }
    }

   return (
        <div className='bsw-day-picker'>
            {variant === 'input'
                ? <div>To Be Created</div>
               : <DayPicker
                   selectedDays={selectedDays}
                   onDayClick={handleDayClick}
                   onMonthChange={(month) => handleYearMonthChange(month)}
                   disabledDays={day => isDayDisabled(day, enabledDays, disabled)}
                   weekdaysLong={weekdaysLong}
                   weekdaysShort={weekdaysShortLabel}
                   months={monthsLabel}
                   month={initialDate || minDate}
                   fromMonth={minDate}
                   toMonth={maxDate}
                   showOutsideDays={false}
                   locale={locale}
                />
            }
        </div>
    )
}

DatePicker.propTypes = {
    disabled: PropTypes.any,
    enabledDays: PropTypes.array,
    initialDate: PropTypes.instanceOf(Date),
    locale: PropTypes.string,
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    months: PropTypes.string,
    onDayClick: PropTypes.func,
    onMonthChange: PropTypes.func,
    selectedDays: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.instanceOf(Date),
        PropTypes.object,
    ]),
    variant: PropTypes.oneOf(['inline', 'input']),
    weekdaysLong: PropTypes.string,
    weekdaysShort: PropTypes.string,
    yearsBackward: PropTypes.number,
    yearsForward: PropTypes.number
};